import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "relative z-50",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = { class: "fixed inset-0 z-10 flex items-center justify-center p-4" }
const _hoisted_3 = {
  class: "relative flex w-full max-w-md flex-col overflow-hidden rounded-lg bg-white shadow-xl",
  style: {"max-height":"80vh"}
}
const _hoisted_4 = { class: "flex items-center justify-between border-b border-greyLight px-4 py-3" }
const _hoisted_5 = { class: "truncate pr-3 text-sm font-semibold text-grey" }
const _hoisted_6 = {
  class: "flex-1 overflow-y-auto bg-background p-4",
  style: {"min-height":"0"}
}
const _hoisted_7 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-10 text-grey"
}
const _hoisted_8 = {
  key: 1,
  class: "flex flex-col items-center justify-center py-10 text-center text-grey"
}
const _hoisted_9 = { class: "mt-1 text-xs text-grey text-opacity-50" }
const _hoisted_10 = {
  ref: "pdfContainer",
  class: "pdf-pages"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, {
    name: "modal",
    duration: 300
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "fixed inset-0 bg-gray-400 bg-opacity-75 transition-opacity",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.fileName), 1),
              _createElementVNode("button", {
                type: "button",
                class: "flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-greyLight text-grey",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
              }, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("i", { class: "fas fa-times" }, null, -1)
              ]))])
            ]),
            _createElementVNode("div", _hoisted_6, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[3] || (_cache[3] = [
                    _createElementVNode("div", { class: "h-8 w-8 animate-spin rounded-full border-b-2 border-[#FFD92E]" }, null, -1),
                    _createElementVNode("div", { class: "mt-3 text-sm text-grey text-opacity-50" }, "Загружаем документ...", -1)
                  ]))]))
                : _createCommentVNode("", true),
              (_ctx.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fas fa-file-excel text-3xl text-red" }, null, -1)),
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "mt-3 text-sm" }, "Не удалось открыть документ", -1)),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.error), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, null, 512)
            ])
          ])
        ])
      ], 512), [
        [_vShow, _ctx.state]
      ])
    ]),
    _: 1
  }))
}